import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { Route as rootRoute } from "./__root";

// Área privada de un programa digital: login, evaluación inicial, portal de progreso,
// entrenamiento guiado y errores frecuentes — todo en una sola pantalla con navegación
// interna (mismo patrón que /portal). Pantalla completa (ver isAppShell en __root.tsx), sin
// nav/footer del sitio público.
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/mi-programa/$slug",
  head: () => ({ meta: [{ name: "robots", content: "noindex, nofollow" }] }),
  component: lazyRouteComponent(() => import("./programa-digital-page"), "ProgramaDigitalPage"),
});
